import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Modal, Popconfirm, Select } from "antd";
import QrScanner from "qr-scanner";
import QRCode from "react-qr-code";
import QrFrame from "../../../App/Assets/qr-frame.svg";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import ProgressModal from '../../../App/Utils/ProgressModal'
import GeneralDetails from "../Components/GeneralDetails";
import { DataProvider } from "../../DataProvider";
import PackageDetails from "../Components/PackageDetails";
import DeliveryDetails from "../Components/DeliveryDetails";
import OtherDetails from "../Components/OtherDetails";
import moment from "moment";

const ViewPackage = (props) => {
    const dataProvider = new DataProvider();
    const formRef = useRef();
    const qrRef = useRef();
    const scanner = useRef();
    const videoEl = useRef(null);
    const qrBoxEl = useRef(null);
    const [qrOn, setQrOn] = useState(true);

    const [showProgress, setShowProgress] = useState(true);
    const [showQRCode, setShowQRCode] = useState(false);
    const [mstQRCode, setMstQRCode] = useState([]);
    const [state, setState] = useState({
        dropdownValues: {},
        initialValues: {},
        routeName: props.location.pathname.split("/").pop(),
    });

    const fetchQRDropdownValues = () => {
        dataProvider.getDropdownValues('MstQRCode', "&is_used=false")
            .then((response) => {
                if (response.ok) {
                    response.json().then((data) => {
                        setMstQRCode(data.results)
                    })
                } else {
                    response.json().then((responseJson) => {
                        openNotification("error", "Error", responseJson["message"]);
                    });
                }
            }).catch((exception) => openNotification("error", "Error", "Error connecting server"))
    }

    const onFinish = (values) => {
        setShowProgress(true);
        const formData = new FormData()
        const supplierDetails = JSON.parse(values['supplier'])
        values['supplier'] = supplierDetails['key']
        values['received_date'] = values['received_date'].format('YYYY-MM-DD');
        values['packing_list'].forEach((item, i) => {
            formData.append('packing_list-' + i, item.originFileObj)
        })
        values['photograph'].forEach((item, i) => {
            formData.append('photograph-' + i, item.originFileObj)
        })
        formData.append('data', JSON.stringify(values))
        dataProvider.updatePackage(state.routeName, formData)
            .then(response => {
                setShowProgress(false);
                if (response.ok) {
                    response.json().then(responseJson => {
                        openNotification("success", "Success", responseJson["message"])
                        setTimeout(() => window.location.reload(), 1000)
                    })
                } else {
                    response.json().then(responseJson => {
                        openNotification("error", "Error", responseJson["message"])
                    })
                }
            }).catch(error => {
                openNotification("error", "Error", "Error connecting server")
                setShowProgress(false);
            })
    };

    const assignQRCode = (values) => {
        const formData = new FormData()
        formData.append('data', JSON.stringify(values))
        dataProvider.assignQRCode(state.routeName, formData)
            .then(response => {
                setShowProgress(false);
                if (response.ok) {
                    response.json().then(responseJson => {
                        openNotification("success", "Success", responseJson["message"])
                        setTimeout(() => window.location.reload(), 1000)
                    })
                } else {
                    response.json().then(responseJson => {
                        openNotification("error", "Error", responseJson["message"])
                    })
                }
            }).catch(error => {
                openNotification("error", "Error", "Error connecting server")
                setShowProgress(false);
            })
    };

    useEffect(() => { }, [showProgress])

    useEffect(() => {
        fetchQRDropdownValues();
        dataProvider.getPackageInfo(state.routeName)
            .then(response => {
                if (response.ok) {
                    response.json().then(responseJson => {
                        const data = responseJson['data']
                        data['received_date'] = data['received_date'] ? moment(data['received_date']) : ''
                        setState({ ...state, initialValues: responseJson['data'] })
                        setShowProgress(false);
                        openNotification("success", "Success", responseJson["message"])
                    })
                } else {
                    response.json().then(responseJson => {
                        openNotification("error", "Error", responseJson["message"])
                    })
                }
            }).catch(error => {
                openNotification("error", "Error", "Error connecting server")
                setShowProgress(false);
            })

    }, [])

    const onScanSuccess = (result) => {
        if (result && result['data']) {
            const qrCode = mstQRCode.filter(x => x.value == result['data'])
            if (qrCode.length > 0) {
                alert("QR Code scanned successfully! press 'Assign' to submit")
                qrRef.current.setFieldValue('qr_code_value', qrCode[0]['id'])
            } else {
                alert("QR code already in use!")
            }

        }
    };

    useEffect(() => {
        if (state.initialValues.hasOwnProperty('qr_code_value') && state.initialValues['qr_code_value'].length <= 0) {
            if (videoEl?.current && !scanner.current) {
                scanner.current = new QrScanner(videoEl?.current, onScanSuccess, {
                    preferredCamera: "environment",
                    highlightScanRegion: true,
                    highlightCodeOutline: true,
                    overlay: qrBoxEl?.current || undefined,
                });
                scanner?.current
                    ?.start()
                    .then(() => setQrOn(true))
                    .catch((err) => {
                        if (err) setQrOn(false);
                    });
            }
            return () => {
                if (!videoEl?.current) {
                    scanner?.current?.stop();
                }
            };
        }
    }, [showQRCode]);


    return (
        <>
            {showProgress &&
                <ProgressModal showProgress={true} />}
            {Object.values(state.initialValues).length>0 && <>
                <div className="form-box" style={{ padding: "10px" }}>
                    <Button onClick={() => props.history.replace('/PROCUREMENT/AllMaterial')}>Back</Button>
                    <Button
                        onClick={() => setShowQRCode(true)}
                        style={{ float: "right" }}
                        type="primary">
                        QR Code
                    </Button>
                </div>
                <Form
                    className="ant-form ant-form-vertical"
                    initialValues={state.initialValues}
                    onFinish={onFinish}
                    ref={formRef}>
                    <div className="row form-box" style={{ paddingTop: "10px" }}>
                        <GeneralDetails
                            disabled={true}
                            initialValues={state.initialValues}
                            formRef={formRef} />
                    </div>
                    <div className="row form-box" >
                        <legend className="form-legend">Package Details</legend>
                        <PackageDetails
                            initialValues={state.initialValues}
                            formRef={formRef} />
                    </div>
                    <div className="row form-box" >
                        <legend className="form-legend">Delivery Details</legend>
                        <DeliveryDetails
                            initialValues={state.initialValues}
                            formRef={formRef} />
                    </div>
                    <div className="row form-box" style={{ paddingTop: "10px" }}>
                        <OtherDetails
                            initialValues={state.initialValues}
                            formRef={formRef} />
                    </div>
                    <div style={{ textAlign: "right", marginRight: "15px" }}>
                        <Button
                            htmlType="submit"
                            type="primary">Update
                        </Button>
                    </div>
                </Form >
                <Form ref={qrRef} onFinish={assignQRCode}>
                    <Modal
                        onCancel={() => setShowQRCode(false)}
                        okText={state.initialValues['qr_code_value'].length <= 0 ? "Assign" : "Ok"}
                        onOk={() => state.initialValues['qr_code_value'].length <= 0 ? qrRef.current.submit() : setShowQRCode(false)}
                        visible={showQRCode}>
                        <>
                            {state.initialValues['qr_code_value'].length <= 0 && <>
                                <center>
                                    <Form.Item required name="qr_code_value" label="">
                                        <Select
                                            allowClear
                                            showSearch
                                            style={{ width: "100%" }}
                                            placeholder="Select QR Code Value"
                                            options={mstQRCode.map((val) => ({
                                                value: val.id,
                                                label: val.value,
                                            }))} />
                                    </Form.Item>
                                </center>
                                <br /><br />
                            </>}
                            {state.initialValues['qr_code_value'].length > 0 ?
                                <QRCode
                                    size={256}
                                    style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                    value={state.initialValues['qr_code_value']}
                                    viewBox={`0 0 256 256`}
                                /> :
                                <div className="qr-reader">
                                    <video ref={videoEl}></video>
                                    <div ref={qrBoxEl} className="qr-box">
                                        <img
                                            src={QrFrame}
                                            alt="Qr Frame"
                                            width={256}
                                            height={256}
                                            className="qr-frame"
                                        />
                                    </div>
                                </div>}
                        </>

                    </Modal>
                </Form>
            </>}
        </>

    );
};

export default ViewPackage;
